export const MIXPANEL_EVENTS = {
    SIGNIN: {
        VIEW_HOME_SCREEN: 'view_widget_home_screen',
        SIGN_IN: 'action_widget_signin',
        EMAIL: 'action_widget_email',
        OTP: 'action_widget_otp',
    },
    KYC: {
        SOF: 'action_widget_kyc_sof',
        PERSONAL_DETAILS: 'action_widget_kyc_personal_details',
        ADDRESS: 'action_widget_kyc_address',
        SOURCE_OF_FUNDS: 'action_widget_kyc_source_of_funds',
        NATIONALITY: 'action_widget_kyc_nationality',
        ID_NUMBER: 'action_widget_kyc_id_number',
        EOF: 'view_widget_kyc_eof',
        CHECK_STATUS: 'action_widget_kyc_check_status',
        RETRY_VERIFICATION: 'action_widget_kyc_retry_verification',
    },
    BUY: {
        BUY: 'action_widget_buy',
        WALLET_ADDRESS: 'action_widget_wallet_address',
        BANK_DEPOSIT: 'action_widget_buy_payment',
        MOMO_DEPOSIT: 'action_widget_buy_payment',
        EOF: 'view_widget_buy_eof',
        RETRY_DEPOSIT: 'action_widget_retry_deposit',
        MY_ACCOUNT: 'action_widget_my_account',
        EFT_DEPOSIT: 'action_widget_buy_payment',
    },
    SELL: {
        SELL: 'action_widget_sell',
        PAYOUT_DETAILS: 'action_widget_sell_payout_details',
        CONFIRM_SENT_TOKEN: 'action_widget_confirm_sent_token',
        EOF: 'view_widget_sell_eof',
    },
    PAYMENT_METHOD: 'action_widget_payment_method',
    ACCEPT_QUOTE: 'action_widget_accept_quote',
    MY_ACCOUNT: 'action_widget_my_account',
};
export function trackEvent(event, props) {
    mixpanel.track(event, props);
}
export default mixpanel;
